import { render } from "./batchUpdateEmployeeApprovalPermissions.vue?vue&type=template&id=6d4a20e2&scoped=true"
import script from "./batchUpdateEmployeeApprovalPermissions.vue?vue&type=script&lang=js"
export * from "./batchUpdateEmployeeApprovalPermissions.vue?vue&type=script&lang=js"

import "./batchUpdateEmployeeApprovalPermissions.vue?vue&type=style&index=0&id=6d4a20e2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4a20e2"]])

export default __exports__